import React from 'react';
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Space,
} from 'antd';
import { SaveOutlined, CloseOutlined } from '@ant-design/icons';
import TextEditor from 'react-quill';
import {
  message,
  FormLabel,
  HelpMessage,
  UploadImage,
} from 'components/common';
import { isHTML } from 'utils';
import { optionList } from './SortListTemplateSelector';

type Props = {
  currentTemplate: string;
  onClose: Function;
  onSavdTemplate: Function;
  sortList: StringKAnyVPair[];
  visible: boolean;
};

const initValues = (sl: StringKAnyVPair[]) => {
  const list = JSON.parse(JSON.stringify(sl));

  list.forEach((sl: any) => {
    if (Array.isArray(sl.Settings)) {
      sl.Settings.forEach((s: any) => {
        if (['Footer', 'Header'].indexOf(s.Name) > -1) {
          if (s.description) {
            if (!isHTML(s.description)) {
              //console.log('sss', s);
              s.description = `<p>${s.description}</p>`;
            }
          }
        }
      });
    }
  });
  //setSortList(list);
  return list;
};

const SortListTemplateEditor = (props: Props) => {
  const { useState } = React;
  const [currentTemplate, setCurrentTemplate] = useState(props.currentTemplate);
  const [isChanged, setIsChanged] = useState(false);
  const [sortList, setSortList] = useState<StringKAnyVPair[]>(initValues(props.sortList));
  const [form] = Form.useForm();

  const barcodeOptionList = [
    {
        label: 'ChannelOrderId',
        value: '0'
    },
    {
        label: 'ChannelOrderId with prefix',
        value: '1'
    }
  ];

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  };

  const dialogFooter = () => {
    return (<>
      <Row justify="end">
        <Space>
          <Button
            onClick={onCancel}
          >
            <CloseOutlined />
            Cancel
          </Button>
          <Button
            disabled={!isChanged}
            onClick={onSaveTemplate}
            type="primary"
          >
            <SaveOutlined />
            Save
          </Button>
        </Space>
      </Row>
    </>);
  };

  const getInitialValue = (key: string) => {
    const tpl = sortList.find(t => t.Value === currentTemplate);
    const vd: StringKAnyVPair = {
      Footer: '',
      Barcode: '0',
      Header: '',
      Logo: '',
    }

    if (tpl && Array.isArray(tpl.Settings)) {
      const setting = tpl.Settings.find(ts => ts.Name === key)

      if (setting && typeof setting === 'object') {
        switch(key) {
          case 'Barcode':
            vd[key] = setting.Value || setting.DefaultValue || vd[key];
            break;
          case 'Footer':
          case 'Header':
            vd[key] = setting.description || setting.DefaultValue || vd[key];
            break;
          case 'Logo':
            vd[key] = setting.Value|| vd[key];
            break;

          default:
            break;
        }
      }
    }

    return vd[key] || '';
  };

  const onCancel = () => {
    props.onClose();
  };

  const onFormValuesChange = (changedValues: any, allValues: any) => {
    //console.log("Changed:", changedValues);
    //console.log("All values:", allValues);
    if (Object.keys(changedValues).length > 0) {
      setIsChanged(true);
    }
  };

  const onSaveTemplate = () => {
    saveTemplate();
  };

  const onSelectTemplate = (val: any) => {
    if (sortList.length > 0) {
      console.log('on select');
      saveTemplate();
    }

    setCurrentTemplate(val);
  };

  const saveTemplate = () => {
    const tpl = sortList.find(t => t.Value === currentTemplate);

    if (tpl) {
      const valDict = form.getFieldsValue();
      const rawDict: StringKAnyVPair = {};
      const setDict: StringKAnyVPair = {};

      if (!Array.isArray(tpl.Settings)) tpl.Settings = [];

      tpl.Settings.forEach((t: any) => rawDict[t.Name] = t);
      setDict['Header'] = rawDict['Header'] ? rawDict['Header'] : defaultTextSetting({Name: 'Header', Label: 'Header', Seq: 1});
      setDict['Barcode'] = rawDict['Barcode'] ? rawDict['Barcode'] : defaultBarcodeSetting({Name: 'Barcode', Label: 'Barcode', Seq: 2});
      setDict['Footer'] = rawDict['Footer'] ? rawDict['Footer'] : defaultTextSetting({Name: 'Footer', Label: 'Footer', Seq: 3});
      setDict['Logo'] = rawDict['Logo'] ? rawDict['Logo'] : defaultTextSetting({Name: 'Logo', Label: 'Logo', Seq: 4});
      setDict['Header'].description = valDict['Header'];
      setDict['Barcode'].Value = valDict['Barcode'];
      setDict['Footer'].description = valDict['Footer'];
      setDict['Logo'].Value = valDict['Logo'];
      tpl.Settings = [
        setDict['Header'],
        setDict['Barcode'],
        setDict['Footer'],
        setDict['Logo'],
      ];
      //console.log('tpl', tpl, valDict, rawDict, setDict);
      setSortList([...sortList]);
      //props.onSavdTemplate(sortList);
      props.onSavdTemplate(sortList, valDict);
      onCancel();
    } else {
      message.warning('The template setting data was not found');
    }
  };

  //console.log('props', props, currentTemplate);
  return (<>
    <Modal
      centered
      destroyOnClose={true}
      footer={dialogFooter()}
      getContainer={false}
      maskClosable={false}
      onCancel={onCancel}
      title={'Edit Sort List Templater'}
      visible={props.visible}
      width={900}
    >
      <Row className="ant-form-item">
        <Col className="ant-form-item-label" span={6}>
          <label>
            <FormLabel>Sort List Template</FormLabel>
          </label>
        </Col>
        <Col span={14}>
          <Select
            onChange={onSelectTemplate}
            options={optionList(sortList)}
            value={currentTemplate}
          />
        </Col>
      </Row>
      <Form {...layout} form={form} onValuesChange={onFormValuesChange}>
        <Form.Item
          name="Header"
          initialValue={getInitialValue('Header')}
          label={
            <>
              <FormLabel noColon>Header</FormLabel>
              <HelpMessage helpId={2} />:
            </>
          }
        >
          <TextEditor theme="snow" />
        </Form.Item>
        <Form.Item
          name="Barcode"
          initialValue={getInitialValue('Barcode')}
          label={
            <>
              <FormLabel>Barcode</FormLabel>
            </>
          }
        >
          <Select
            options={barcodeOptionList}
          />
        </Form.Item>
        <Form.Item
          name="Footer"
          initialValue={getInitialValue('Footer')}
          label={
            <>
              <FormLabel noColon>Footer</FormLabel>
              <HelpMessage helpId={2} />:
            </>
          }
        >
          <TextEditor theme="snow" />
        </Form.Item>
        <Form.Item
          name="Logo"
          initialValue={getInitialValue('Logo')}
          label={<FormLabel>Logo</FormLabel>}
        >
          <UploadImage style={{ marginTop: 5, width: 180 }} />
        </Form.Item>
      </Form>
    </Modal>
  </>);
};

export default SortListTemplateEditor;

export const defaultBarcodeSetting = (val: StringKAnyVPair) => {
  return {
    //"Seq": 2,
    //"Name": "Barcode",
    "UIType": 6,
    "DataType": 1,
    //"Label": "Barcode",
    "description": "Specify Barcode",
    "DefaultValue": "0",
    "Options": [
      {
        "Name": "ChannelOrderId",
        "Value": "0"
      },
      {
        "Name": "ChannelOrderId with prefix",
        "Value": "1"
      }
    ],
    "Value": "0",
  };
};

export const defaultTextSetting = (val: StringKAnyVPair) => {
  return {
    //"Seq": 1,
    //"Name": "",
    "UIType": 13,
    "DataType": 0,
    //"Label": "",
    "description": "",
    "DefaultValue": "",
    "Options": [],
    ...val,
  };
};
